<template>
  <div>
    <div class="container">
      <el-row style="margin-bottom:10px">
        <el-col :span="12">
          <span>年份：</span>
          <el-date-picker v-model="value"
                          size="mini"
                          type="year"
                          value-format='yyyy'
                          style="width:120px;margin-right:10px"
                          placeholder="选择年">
          </el-date-picker>
          <el-button type="primary"
                     @click="ss"
                     size="mini">搜索</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <p class="text">合同电量分月</p>
        </el-col>
        <el-col :span="8">
        </el-col>
        <el-col :span="8"
                style="justify-content:flex-end">
          <el-button type="primary"
                     @click="history"
                     v-if="show($store.state.menuList.htdllist,'see')"
                     size="mini">查看历史</el-button>
          <el-button type="primary"
                     @click="dialogFormVisible=true"
                     v-if="show($store.state.menuList.htdllist,'add')"
                     size="mini">新增合同电量</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-table border
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%;margin-top:20px">
          <el-table-column label="合同电量(kW·h)">
            <template slot-scope="scope">{{ scope.row.contractEleQuantity }}</template>
          </el-table-column>
          <el-table-column prop="signPrice"
                           label="签约价格(元/千瓦时)">
          </el-table-column>
          <el-table-column prop="jan"
                           label="1月">
          </el-table-column>
          <el-table-column prop="feb"
                           label="2月">
          </el-table-column>
          <el-table-column prop="mar"
                           label="3月">
          </el-table-column>
          <el-table-column prop="apr"
                           label="4月">
          </el-table-column>
          <el-table-column prop="may"
                           label="5月">
          </el-table-column>
          <el-table-column prop="jun"
                           label="6月">
          </el-table-column>
          <el-table-column prop="jul"
                           label="7月">
          </el-table-column>
          <el-table-column prop="aug"
                           label="8月">
          </el-table-column>
          <el-table-column prop="sept"
                           label="9月">
          </el-table-column>
          <el-table-column prop="oct"
                           label="10月">
          </el-table-column>
          <el-table-column prop="nov"
                           label="11月">
          </el-table-column>
          <el-table-column prop="dece"
                           label="12月">
          </el-table-column>
          <el-table-column prop="address"
                           label="操作"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="dialogFormVisible3=true;handleClick(scope.row)"
                         v-if="show($store.state.menuList.htdllist,'delete')"
                         type="text"
                         size="small">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row style="margin-top:40px">
        <el-col :span="8">
          <p class="text">交易品种电量分月</p>
        </el-col>
        <el-col :span="8">
        </el-col>
        <el-col :span="8"
                style="justify-content: flex-end;display:flex">
          <el-upload class="upload-demo"
                     action
                     :show-file-list="false"
                     :http-request="uploadfile">
            <el-button size="small"
                       v-if="show($store.state.menuList.htdllist,'import')"
                       type="primary">导入</el-button>
          </el-upload>
          <el-button type="primary"
                     style="margin-left:20px"
                     size="mini"
                     v-if="show($store.state.menuList.htdllist,'export')"
                     @click="exportMethod('https://c.cesc-energy.com/service/contractTradeType/export','合同电量.xlsx')">导出数据</el-button>
          <el-button type="primary"
                     style="margin-left:20px"
                     size="mini"
                     v-if="show($store.state.menuList.htdllist,'exportT')"
                     @click="exportMethod('https://c.cesc-energy.com/service/contractTradeType/export/template','合同电量.xlsx')">导出模板</el-button>
          <el-button type="primary"
                     @click="add"
                     style="margin-left:20px"
                     v-if="show($store.state.menuList.htdllist,'add')"
                     size="mini">新增交易品种</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-table border
                  ref="multipleTable"
                  :data="tableData1"
                  tooltip-effect="dark"
                  style="width: 1600px;margin-top:20px；max-width:200%">
          <el-table-column prop="year"
                           label="年份">
          </el-table-column>
          <el-table-column label="交易品种">
            <template slot-scope="scope"><span v-if="scope.row.tradeType==1">双边协商</span>
              <span v-if="scope.row.tradeType==2">集中竞价</span>
              <span v-if="scope.row.tradeType==3">挂牌</span></template>
          </el-table-column>

          <el-table-column prop="jan"
                           label="1月">
          </el-table-column>
          <el-table-column prop="feb"
                           label="2月">
          </el-table-column>
          <el-table-column prop="mar"
                           label="3月">
          </el-table-column>
          <el-table-column prop="apr"
                           label="4月">
          </el-table-column>
          <el-table-column prop="may"
                           label="5月">
          </el-table-column>
          <el-table-column prop="jun"
                           label="6月">
          </el-table-column>
          <el-table-column prop="jul"
                           label="7月">
          </el-table-column>
          <el-table-column prop="aug"
                           label="8月">
          </el-table-column>
          <el-table-column prop="sept"
                           label="9月">
          </el-table-column>
          <el-table-column prop="oct"
                           label="10月">
          </el-table-column>
          <el-table-column prop="nov"
                           label="11月">
          </el-table-column>
          <el-table-column prop="dece"
                           label="12月">
          </el-table-column>
          <el-table-column prop="remarks"
                           label="备注">
          </el-table-column>
          <el-table-column prop="address"
                           label="操作"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="dialogFormVisible2=true;handleClick1(scope.row)"
                         type="text"
                         v-if="show($store.state.menuList.htdllist,'edit')"
                         size="small">调整</el-button>
              <el-button @click="deleteTable(scope.$index, tableData)"
                         type="text"
                         v-if="show($store.state.menuList.htdllist,'delete')"
                         size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>
    <el-dialog title="新增合同电量"
               style="width:1800px;margin:auto"
               :visible.sync="dialogFormVisible">
      <el-form :model="form"
               ref="form"
               :rules="rules"
               label-width="120px">
        <el-form-item label="电量日期"
                      prop="eleQuantityDate">
          <el-date-picker v-model="form.eleQuantityDate"
                          value-format="yyyy-MM-dd"
                          size="mini">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="签约价格(元/千瓦时)"
                      prop="signPrice">
          <el-input v-model="form.signPrice"
                    oninput="value=value.replace(/[^0-9.-]/g,'')"
                    style="width:220px"
                    size="mini"></el-input>
        </el-form-item>
        <el-form-item label="合同电量(kW·h)"
                      prop="contractEleQuantity">
          <el-input v-model="form.contractEleQuantity"
                    oninput="value=value.replace(/[^0-9.-]/g,'')"
                    style="width:220px"
                    size="mini"></el-input>
        </el-form-item>
        <div>电量分月预测:</div>
        <el-row style="margin:40px 0"
                :gutter="10">

          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jan">
              <p style="text-align:center;line-height:20px">1月</p>
              <el-input v-model="form.jan"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="feb">
              <p style="text-align:center;line-height:20px">2月</p>
              <el-input v-model="form.feb"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="mar">
              <p style="width:100%;text-align:center;line-height:20px">3月</p>
              <el-input v-model="form.mar"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="apr">
              <p style="width:100%;text-align:center;line-height:20px">4月</p>
              <el-input v-model="form.apr"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="may">
              <p style="width:100%;text-align:center;line-height:20px">5月</p>
              <el-input v-model="form.may"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jun">
              <p style="width:100%;text-align:center;line-height:20px">6月</p>
              <el-input v-model="form.jun"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jul">
              <p style="width:100%;text-align:center;line-height:20px">7月</p>
              <el-input v-model="form.jul"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="aug">
              <p style="width:100%;text-align:center;line-height:20px">8月</p>
              <el-input v-model="form.aug"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="sept">
              <p style="width:100%;text-align:center;line-height:20px">9月</p>
              <el-input v-model="form.sept"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="oct">
              <p style="width:100%;text-align:center;line-height:20px">10月</p>
              <el-input v-model="form.oct"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="nov">
              <p style="width:100%;text-align:center;line-height:20px">11月</p>
              <el-input v-model="form.nov"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="dece">
              <p style="width:100%;text-align:center;line-height:20px">12月</p>
              <el-input v-model="form.dece"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label=""
                      label-width="0px"
                      class="btn">
          <el-button @click="dialogFormVisible=false;$refs['form'].resetFields()">取消</el-button>
          <el-button type="primary"
                     @click="submitForm('form')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="修改合同电量"
               style="width:1800px;margin:auto"
               :visible.sync="dialogFormVisible3">
      <el-form :model="form3"
               ref="form3"
               :rules="rules"
               label-width="120px">
        <el-form-item label="电量日期"
                      prop="eleQuantityDate">
          <el-date-picker v-model="form3.eleQuantityDate"
                          value-format="yyyy-MM-dd"
                          size="mini">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="签约价格(元/千瓦时)"
                      prop="signPrice">
          <el-input v-model="form3.signPrice"
                    oninput="value=value.replace(/[^0-9.-]/g,'')"
                    style="width:220px"
                    size="mini"></el-input>
        </el-form-item>
        <el-form-item label="合同电量(kW·h)"
                      prop="contractEleQuantity">
          <el-input v-model="form3.contractEleQuantity"
                    style="width:220px"
                    oninput="value=value.replace(/[^0-9.-]/g,'')"
                    size="mini"></el-input>
        </el-form-item>
        <div>电量分月预测:</div>
        <el-row style="margin:40px 0"
                :gutter="10">

          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jan">
              <p style="text-align:center;line-height:20px">1月</p>
              <el-input v-model="form3.jan"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="feb">
              <p style="text-align:center;line-height:20px">2月</p>
              <el-input v-model="form3.feb"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="mar">
              <p style="width:100%;text-align:center;line-height:20px">3月</p>
              <el-input v-model="form3.mar"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="apr">
              <p style="width:100%;text-align:center;line-height:20px">4月</p>
              <el-input v-model="form3.apr"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="may">
              <p style="width:100%;text-align:center;line-height:20px">5月</p>
              <el-input v-model="form3.may"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jun">
              <p style="width:100%;text-align:center;line-height:20px">6月</p>
              <el-input v-model="form3.jun"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jul">
              <p style="width:100%;text-align:center;line-height:20px">7月</p>
              <el-input v-model="form3.jul"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="aug">
              <p style="width:100%;text-align:center;line-height:20px">8月</p>
              <el-input v-model="form3.aug"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="sept">
              <p style="width:100%;text-align:center;line-height:20px">9月</p>
              <el-input v-model="form3.sept"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="oct">
              <p style="width:100%;text-align:center;line-height:20px">10月</p>
              <el-input v-model="form3.oct"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="nov">
              <p style="width:100%;text-align:center;line-height:20px">11月</p>
              <el-input v-model="form3.nov"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="dece">
              <p style="width:100%;text-align:center;line-height:20px">12月</p>
              <el-input v-model="form3.dece"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label=""
                      label-width="0px"
                      class="btn">
          <el-button @click="dialogFormVisible3=false">取消</el-button>
          <el-button type="primary"
                     @click="submitForm3('form3')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="历年电量分月预测"
               style="width:1800px;margin:auto"
               :visible.sync="dialogFormVisible1">
      <el-table border
                :data="tableData2"
                tooltip-effect="dark"
                style="width: 100%;margin-top:20px">
        <el-table-column label="合同电量(kW·h)">
          <template slot-scope="scope">{{ scope.row.contractEleQuantity }}</template>
        </el-table-column>
        <el-table-column prop="signPrice"
                         label="签约价格(元/千瓦时)">
        </el-table-column>
        <el-table-column prop="jan"
                         label="1月">
        </el-table-column>
        <el-table-column prop="feb"
                         label="2月">
        </el-table-column>
        <el-table-column prop="mar"
                         label="3月">
        </el-table-column>
        <el-table-column prop="apr"
                         label="4月">
        </el-table-column>
        <el-table-column prop="may"
                         label="5月">
        </el-table-column>
        <el-table-column prop="jun"
                         label="6月">
        </el-table-column>
        <el-table-column prop="jul"
                         label="7月">
        </el-table-column>
        <el-table-column prop="aug"
                         label="8月">
        </el-table-column>
        <el-table-column prop="sept"
                         label="9月">
        </el-table-column>
        <el-table-column prop="oct"
                         label="10月">
        </el-table-column>
        <el-table-column prop="nov"
                         label="11月">
        </el-table-column>
        <el-table-column prop="dece"
                         label="12月">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="title"
               style="width:1800px;margin:auto"
               :visible.sync="dialogFormVisible2">
      <el-form :model="form1"
               ref='form1'
               :rules="rules1"
               label-width="120px">
        <el-form-item label="年份"
                      prop="year">
          <el-date-picker v-model="form1.year"
                          value-format="yyyy"
                          type="year"
                          size="mini">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form1.remarks"
                    style="width:220px"
                    type="textarea"
                    size="mini"></el-input>
        </el-form-item>
        <el-form-item label="交易品种"
                      prop="tradeType">
          <el-select v-model="form1.tradeType"
                     placeholder="请选择">
            <el-option label="双边协商"
                       :value="1">
            </el-option>
            <el-option label="集中竞价"
                       :value="2">
            </el-option>
            <el-option label="挂牌"
                       :value="3">
            </el-option>
          </el-select>
        </el-form-item>
        <div>电量分月预测:</div>
        <el-row style="margin:40px 0"
                :gutter="10">

          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jan">
              <p style="text-align:center;line-height:20px">1月</p>
              <el-input v-model="form1.jan"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="feb">
              <p style="text-align:center;line-height:20px">2月</p>
              <el-input v-model="form1.feb"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="mar">
              <p style="width:100%;text-align:center;line-height:20px">3月</p>
              <el-input v-model="form1.mar"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="apr">
              <p style="width:100%;text-align:center;line-height:20px">4月</p>
              <el-input v-model="form1.apr"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="may">
              <p style="width:100%;text-align:center;line-height:20px">5月</p>
              <el-input v-model="form1.may"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jun">
              <p style="width:100%;text-align:center;line-height:20px">6月</p>
              <el-input v-model="form1.jun"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="jul">
              <p style="width:100%;text-align:center;line-height:20px">7月</p>
              <el-input v-model="form1.jul"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="aug">
              <p style="width:100%;text-align:center;line-height:20px">8月</p>
              <el-input v-model="form1.aug"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="sept">
              <p style="width:100%;text-align:center;line-height:20px">9月</p>
              <el-input v-model="form1.sept"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="oct">
              <p style="width:100%;text-align:center;line-height:20px">10月</p>
              <el-input v-model="form1.oct"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="nov">
              <p style="width:100%;text-align:center;line-height:20px">11月</p>
              <el-input v-model="form1.nov"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  style="flex-wrap:wrap">
            <el-form-item label=""
                          label-width="0"
                          prop="dece">
              <p style="width:100%;text-align:center;line-height:20px">12月</p>
              <el-input v-model="form1.dece"
                        oninput="value=value.replace(/[^0-9.-]/g,'')"
                        size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label=""
                      label-width="0px"
                      class="btn">
          <el-button @click="dialogFormVisible2=false;$refs['form1'].resetFields()">取消</el-button>
          <el-button type="primary"
                     @click="submitForm1('form1')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { postcontractEleQuantity, getcontractEleQuantity, getmenusubmenu, putcontractEleQuantity, postcontractTradeType, getcontractTradeType, putcontractTradeType, deletecontractTradeType, getcontractEleQuantityYear, postcontractEleQuantityFile } from '../../API'
import { parantId } from '../../util/parantId'
import { show } from '../../util/show'
import exportMethod from '../../util/util'
export default {
  data () {
    return {
      tableData: [],
      tableData1: [],
      tableData2: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      value: "",
      form: {
        apr: '',
        aug: '',
        contractEleQuantity: "",
        dece: '',
        eleQuantityDate: "",
        feb: '',
        jan: '',
        jul: '',
        jun: '',
        mar: '',
        may: '',
        nov: '',
        oct: '',
        sept: '',
        signPrice: '',
        year: '',
      },
      rules: {
        apr: { required: true, message: '必填', trigger: 'blur' },
        aug: { required: true, message: '必填', trigger: 'blur' },
        contractEleQuantity: { required: true, message: '必填', trigger: 'blur' },
        dece: { required: true, message: '必填', trigger: 'blur' },
        eleQuantityDate: { required: true, message: '必填', trigger: 'blur' },
        feb: { required: true, message: '必填', trigger: 'blur' },
        jan: { required: true, message: '必填', trigger: 'blur' },
        jul: { required: true, message: '必填', trigger: 'blur' },
        jun: { required: true, message: '必填', trigger: 'blur' },
        mar: { required: true, message: '必填', trigger: 'blur' },
        may: { required: true, message: '必填', trigger: 'blur' },
        nov: { required: true, message: '必填', trigger: 'blur' },
        oct: { required: true, message: '必填', trigger: 'blur' },
        sept: { required: true, message: '必填', trigger: 'blur' },
        signPrice: { required: true, message: '必填', trigger: 'blur' },

      },
      rules1: {
        apr: { required: true, message: '必填', trigger: 'blur' },
        aug: { required: true, message: '必填', trigger: 'blur' },
        dece: { required: true, message: '必填', trigger: 'blur' },
        feb: { required: true, message: '必填', trigger: 'blur' },
        jan: { required: true, message: '必填', trigger: 'blur' },
        jul: { required: true, message: '必填', trigger: 'blur' },
        jun: { required: true, message: '必填', trigger: 'blur' },
        mar: { required: true, message: '必填', trigger: 'blur' },
        may: { required: true, message: '必填', trigger: 'blur' },
        nov: { required: true, message: '必填', trigger: 'blur' },
        oct: { required: true, message: '必填', trigger: 'blur' },
        sept: { required: true, message: '必填', trigger: 'blur' },
        year: { required: true, message: '必填', trigger: 'blur' },
        remarks: { required: true, message: '必填', trigger: 'blur' },
        tradeType: { required: true, message: '必填', trigger: 'blur' },

      },
      form3: {},
      form1: {
        apr: '',
        aug: '',
        dece: '',
        feb: '',
        jan: '',
        jul: '',
        jun: '',
        mar: '',
        may: '',
        nov: '',
        oct: '',
        sept: '',
        signPrice: '',
        year: '',
        remarks: '',
        tradeType: ''
      },
      title: '新增交易品种'
    }
  },
  created () {
    getcontractEleQuantity(localStorage.getItem('contractId')).then(res => {
      if (res.code === 0) {
        this.tableData = res.data
      }
    })
    getcontractTradeType(localStorage.getItem('contractId')).then(res => {
      if (res.code === 0) {
        this.tableData1 = res.data
      }
    })
    parantId(this.$store.state.permissionList.data, this.$route.path, this.$store)
  },
  watch: {
    "$store.state.parantId.parantId" (newval, olval) {
      getmenusubmenu(newval).then(res => {
        if (res.code === 0) {
          this.$store.commit('menuList/COMMIT_DATA', { name: 'htdllist', data: res.data })
        }
      })
    },
  },
  methods: {
    show,
    exportMethod,
    uploadfile (item) {
      let fileObj = item.file
      let name = fileObj.name;
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        return false;
      }
      const form = new FormData()// FormData 对象
      form.append('file', fileObj)// 文件对象  'upload'是后台接收的参数名
      postcontractEleQuantityFile(form).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        }
        else {
          this.$message({
            message: '导入失败',
            type: 'error'
          });
        }
      })
    },
    init () {
      getcontractEleQuantity(localStorage.getItem('contractId')).then(res => {
        if (res.code === 0) {
          this.tableData = res.data
        }
      })
      getcontractTradeType(localStorage.getItem('contractId')).then(res => {
        if (res.code === 0) {
          this.tableData1 = res.data
        }
      })
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },

    ss () {
      let par = this.value ? localStorage.getItem('contractId') + '/' + this.value : localStorage.getItem('contractId')
      getcontractEleQuantity(par).then(res => {
        if (res.code === 0) {
          this.tableData = res.data
        }
      })
      getcontractTradeType(par).then(res => {
        if (res.code === 0) {
          this.tableData1 = res.data
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.form
          params.contractId = localStorage.getItem('contractId')
          postcontractEleQuantity(params).then(res => {
            if (res.code === 0) {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.dialogFormVisible = false
              this.form = {}
              this.$refs[formName].resetFields();
            }
          })
          this.dialogFormVisible = false
          this.tableData.push(params)
        } else {
          return false;
        }
      });
    },
    submitForm3 (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form3.contractId = localStorage.getItem('contractId')
          putcontractEleQuantity(this.form3).then(res => {
            if (res.code === 0) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.init()
            }
          })
          this.dialogFormVisible3 = false
        } else {
          return false;
        }
      });
    },
    submitForm1 (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form1.tradeTypeId >= 0) {
            this.form1.year = new Date(this.form1.year).getFullYear()
            putcontractTradeType(this.form1).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.init()
              }
            })
            this.dialogFormVisible2 = false
          }
          else {
            this.form1.contractId = localStorage.getItem('contractId')
            postcontractTradeType(this.form1).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.dialogFormVisible2 = false
                this.tableData1.push(this.form1)
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    deleteTable (index, rows) {
      this.$alert('是否删除', '删除', {
        confirmButtonText: '确定',
        callback: action => {
          this.$message({
            type: 'info',
            message: `action: ${action}`
          });
        }
      });
    },
    update () {
      this.dialogFormVisible = true
    },
    handleClick (row) {
      this.form3 = JSON.parse(JSON.stringify(row))
    },
    handleClick1 (row) {
      this.form1 = row
      this.form1.year = new Date(row.year, 1, 1)
      this.title = '编辑交易品种'
    },
    add () {
      this.dialogFormVisible2 = true
      this.form1 = {}
      this.title = '新增交易品种'
    },
    history () {
      this.dialogFormVisible1 = true
      getcontractEleQuantity(localStorage.getItem('contractId')).then(res => {
        if (res.code === 0) {
          this.tableData2 = res.data
        }
      })
    },
    add1 () {
      this.dialogFormVisible2 = true
    },
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
  border: none;
  background-color: #fff;
}
.btn {
  text-align: center;
}

/deep/ .el-table th.is-leaf {
  background-color: rgb(249, 250, 252);
}
.el-col {
  height: 40px;
  align-content: center;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666666;
}
</style>